import { render, staticRenderFns } from "./gj-desc.vue?vue&type=template&id=216efe72&scoped=true&"
import script from "./gj-desc.vue?vue&type=script&lang=js&"
export * from "./gj-desc.vue?vue&type=script&lang=js&"
import style0 from "./gj-desc.vue?vue&type=style&index=0&id=216efe72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216efe72",
  null
  
)

export default component.exports